export function isWidgetData(data) {
    return data && 'is_widget' in data && data.is_widget === true;
}
export function isKnowledgeCardData(data) {
    return data && 'card_type' in data;
}
export function isCodeInterpreterImage(data) {
    return ('is_code_interpreter' in data && data.is_code_interpreter === true && data.is_image === true);
}
//# sourceMappingURL=types.js.map